import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import { documentList, consigneeResource, consigneeDefault, delConsignee, mailingConfig, mailingDetail } from '../request';
import { documentListColumns, consigneeListColumns, documentColumns } from '../utils';
import consigneeModel from './consigneeModel.vue';
import { mapState } from 'vuex';
export default {
  components: {
    topTitle,
    consigneeModel
  },
  computed: {
    ...mapState({
      tag: state => state.user.accountInfo.tag
    })
  },
  props: {
    claimsId: {
      type: Number,
      default: 0
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      documentColumns,
      documentListColumns,
      consigneeListColumns,
      documentList: [],
      consigneeList: [],
      // previewVisible:false,
      id: '',
      selectedRowKeysArray: [],
      consigneeShow: false,
      infoData: {}
    };
  },
  // computed:{
  //   rowSelection() {
  //     return {
  //       type:'radio',
  //       onChange: (selectedRowKeys, selectedRows) => {
  //         console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
  //       },
  //       getCheckboxProps: record => ({
  //         props: {
  //           disabled: record.type === 'Disabled User', // Column configuration not to be checked
  //           name: record.name
  //         }
  //       })
  //     };
  //   }
  // },
  created() {
    setTimeout(() => {
      this.init();
    }, 400);
  },
  methods: {
    async init() {
      console.log(this.edit);
      this.id = this.claimsId;
      if (this.edit) {
        this.documentList = await documentList({
          claimsId: this.id
        });
        this.consigneeList = await consigneeResource({});
        let arr = this.consigneeList.filter(item => item.isDefault);
        if (arr.length == 0) {
          this.selectedRowKeysArray = this.consigneeList.length == 0 ? [] : [this.consigneeList[0].consigneeId];
        } else {
          this.selectedRowKeysArray = [arr[0].consigneeId];
        }
      } else {
        this.infoData = await mailingDetail({
          claimsId: this.claimsId,
          isSelf: this.tag == 1 ? true : false
        });
      }
    },
    mailChange(index) {
      this.documentList[index].isChecked = !this.documentList[index].isChecked;
    },
    addConsigneeFun() {
      this.consigneeShow = true;
      this.$nextTick(() => {
        this.$refs.consigneeForm.init(this.id);
      });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeysArray = selectedRowKeys;
    },
    async consigneeFun(val, type) {
      console.log(val, 222);
      if (val) {
        this.selectedRowKeysArray = [val];
        this.consigneeShow = false;
      }
      this.consigneeList = await consigneeResource({});
      if (type == 1) {
        let arr = this.consigneeList.filter(item => item.isDefault);
        this.selectedRowKeysArray = [arr[0].consigneeId];
      } else {
        let arr = this.consigneeList.filter(item => item => item.consigneeId == this.selectedRowKeysArray[0]);
        if (arr.length == 0) {
          this.selectedRowKeysArray = this.consigneeList.length == 0 ? [] : [this.consigneeList[0].consigneeId];
        } else {
          this.selectedRowKeysArray = [arr[0].consigneeId];
        }
      }
    },
    handleDefault(id) {
      consigneeDefault({
        consigneeId: id,
        default: 1
      }).then(res => {
        this.$message.success(this.$t('操作成功'));
        this.consigneeFun(false, 1);
      });
    },
    handleDel(id) {
      delConsignee({
        consigneeId: id
      }).then(res => {
        this.$message.success(this.$t('删除成功'));
        this.consigneeFun(false, 2);
      });
    },
    handleSure() {
      if (this.selectedRowKeysArray.length == 0) {
        this.$message.error(this.$t('请先选择收件信息'));
        return false;
      }
      const arr = this.documentList.filter(item => item.isChecked);
      if (arr.length == 0) {
        this.$message.error(this.$t('请先选择需要邮寄的资料清单'));
        return false;
      }
      let new_arr = arr.map(item => {
        delete item.isChecked;
        return item;
      });
      mailingConfig({
        claimsId: this.id,
        consigneeId: this.selectedRowKeysArray[0],
        documentList: JSON.stringify(new_arr)
      }).then(res => {
        this.$message.success(this.$t('已通知客户邮寄') + '!');
        // this.$emit('cancel');
        this.$emit('ok');
      });
    }
  }
};